export const exhibitionScenarioConstants = {
    EXHIBITION_SCENARIO_LIST_REQUEST: "EXHIBITION_SCENARIO_LIST_REQUEST",
    EXHIBITION_SCENARIO_LIST_SUCCESS: "EXHIBITION_SCENARIO_LIST_SUCCESS",
    EXHIBITION_SCENARIO_LIST_FAILURE: "EXHIBITION_SCENARIO_LIST_FAILURE",

    EXHIBITION_SCENARIO_DROPDOWN_LIST_REQUEST: "EXHIBITION_SCENARIO_DROPDOWN_LIST_REQUEST",
    EXHIBITION_SCENARIO_DROPDOWN_LIST_SUCCESS: "EXHIBITION_SCENARIO_DROPDOWN_LIST_SUCCESS",
    EXHIBITION_SCENARIO_DROPDOWN_LIST_FAILURE: "EXHIBITION_SCENARIO_DROPDOWN_LIST_FAILURE",

    EXHIBITION_SCENARIO_GET_BY_ID_REQUEST: "EXHIBITION_SCENARIO_GET_BY_ID_REQUEST",
    EXHIBITION_SCENARIO_GET_BY_ID_SUCCESS: "EXHIBITION_SCENARIO_GET_BY_ID_SUCCESS",
    EXHIBITION_SCENARIO_GET_BY_ID_FAILURE: "EXHIBITION_SCENARIO_GET_BY_ID_FAILURE",

    EXHIBITION_SCENARIO_VALIDATION_ERROR: "EXHIBITION_SCENARIO_VALIDATION_ERROR",

    CLEAR_ALL: "CLEAR_ALL"
}